export class NotificationConditions {
  public logicalOperator: number = 0;
  public expressions: { elementId: string, operator: string, value: string }[] = [];

  constructor(init?: Partial<NotificationConditions>) {
    Object.assign(this, init);
  }
}
